import Nullstack from 'nullstack';
export default function IconArrowsRandom({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-arrows-random",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M20 21.004h-4v-4"
  }), "   ", Nullstack.element("path", {
    d: "M16 21.004l5 -5"
  }), "   ", Nullstack.element("path", {
    d: "M6.5 9.504l-3.5 -2l2 -3.504"
  }), "   ", Nullstack.element("path", {
    d: "M3 7.504l6.83 -1.87"
  }), "   ", Nullstack.element("path", {
    d: "M4 16.004l4 -1l1 4"
  }), "   ", Nullstack.element("path", {
    d: "M8 15.004l-3.5 6"
  }), "   ", Nullstack.element("path", {
    d: "M21 5.004l-.5 4l-4 -.5"
  }), "   ", Nullstack.element("path", {
    d: "M20.5 9.004l-4.5 -5.5"
  }), " ");
}